import { type JSX, useMemo } from 'react';
import classNames from 'classnames';

type Align = 'left' | 'center' | 'right';
type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

type SectionTitleProps = {
	readonly className?: string;
	readonly title: string;
	readonly align?: Align;
	readonly tag?: HeadingTag;
};

const classNameComponent = 'c-cnm-section-title';

export const SectionTitle = ({ className, title, align = 'center', tag = 'h2' }: SectionTitleProps) => {
	const wrapperClassName = useMemo(
		() => classNames(classNameComponent, `${classNameComponent}--align-${align}`, className),
		[className, align],
	);
	const Tag = tag as keyof JSX.IntrinsicElements;

	return <Tag className={wrapperClassName}>{title}</Tag>;
};
